<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="模糊搜索">
              <el-input
                v-model="searchCondition.query"
                placeholder="请输入订单号|姓名|身份证|银行卡"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="标记类型">
              <el-select
                clearable
                filterable
                v-model="searchCondition.tag_id"
                class="select-wrapper"
              >
                <el-option v-for="item in mark_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <ScreeCompany :allowField="allowField" @ScreeCompany="ScreeCompany" />
          <div class="table-right">
            <MonthPicker @MonthSearch="MonthSearch" />
            <el-select
              v-model="value"
              placeholder="请选择导出类型"
              @change="selectData"
              class="select-box"
              size="medium"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              :loading="downloadLoading"
              style="margin: 0 0 20px 20px"
              type="primary"
              size="medium"
              icon="el-icon-document"
              @click="handleDownload"
            >
              导出
            </el-button>
          </div>
        </el-row>
		<el-divider></el-divider>
		<el-row v-if="userPermissions.indexOf('withdraw_fast') != -1">
			<el-form :inline="true">
				<el-form-item>
					快捷导出
				</el-form-item>
				<el-form-item>
          <el-select placeholder="请选择税源地" v-if="allowField.includes('settlementId')" v-model="quickForm.settlementId" @change="settlementChange" filterable clearable class="seliput settlement">
            <el-option
              v-for="item in settlementList"
              :key="item.id"
              :label="item.channel_name"
              :value="item.channel_account">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<MonthPicker :addMonth="0" @MonthSearch="MonthSearch_quick" @clear="clearMonth"/>
				</el-form-item>
				<el-form-item>
            <el-button
              style="margin: 0 0 20px"
              type="primary"
              size="medium"
              icon="el-icon-document"
              @click="handleDownload_zip"
            >
              导出
            </el-button>
				</el-form-item>
			</el-form>
		</el-row>
        <ApeTable
          ref="apeTable"
          style="font-size: 12px"
          :data="tradeWithdrawList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <!-- 公司名称 -->
          <el-table-column
            slot="first-column"
            align="left"
            label="公司名称"
          >
            <template slot-scope="scope">
              {{ (scope.row.company && scope.row.company.name) || '-' }}
            </template>
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column
            width="80"
            slot="first-column"
            align="left"
            prop="bank_account_name"
            sortable
            label="姓名"
          >
            <template slot-scope="scope">
              {{ scope.row.bank_account_name }}
            </template>
          </el-table-column>

		<el-table-column
		slot="second-column"
		prop="money"
		align="center"
		sortable
		v-if="isLaowuCompany"
		label="金额类型"
		>
		<template>
		<div>
			<div>税后</div>
		</div>
		</template>
		</el-table-column>
		
		<el-table-column
		slot="second-column"
		prop="money"
		align="center"
		sortable
		label="结算金额"
		v-if="isLaowu"
		>
		<template slot-scope="scope">
		<div>
		<el-tag type="success">¥ {{ scope.row.money }}</el-tag>
		</div>
		</template>
		</el-table-column>
        
          <el-table-column
            slot="second-column"
            prop="money"
            align="center"
            sortable
            :label="isLaowu?'实收金额':'金额'"
          >
            <template slot-scope="scope">
              <div>
                <el-tag type="success" v-if="isLaowu">¥ {{ scope.row.after_tax_money }}</el-tag>
				<el-tag type="success" v-else>¥ {{ scope.row.money }}</el-tag>
              </div>
            </template>
          </el-table-column>
      <el-table-column slot="second-column" v-if="!isLaowuCompany" prop="money" align="center" label="实发金额">
          <template slot-scope="scope">
            {{ scope.row.real_money || 0 }}
          </template>
      </el-table-column>
      <el-table-column slot="second-column" v-if="!isLaowuCompany" prop="money" align="center" label="个税">
          <template slot-scope="scope">
            {{ scope.row.now_tax_money || 0 }}
          </template>
      </el-table-column>
			<el-table-column
			slot="second-column"
			prop="money"
			align="center"
			sortable
			label="增值税"
			v-if="isLaowu"
			>
			<template slot-scope="scope">
			<div>
			<el-tag type="success">¥ {{ scope.row.value_added_tax }}</el-tag>
			</div>
			</template>
			</el-table-column>
			<el-table-column
			slot="second-column"
			prop="money"
			align="center"
			sortable
			label="附加税"
			v-if="isLaowu"
			>
			<template slot-scope="scope">
			<div>
			<el-tag type="success">¥ {{ scope.row.additional_tax }}</el-tag>
			</div>
			</template>
			</el-table-column>
			<el-table-column
			slot="second-column"
			prop="money"
			align="center"
			sortable
			label="个税"
			v-if="isLaowu"
			>
			<template slot-scope="scope">
			<div>
			<el-tag type="success">¥ {{ scope.row.personal_income_tax }}</el-tag>
			</div>
			</template>
			</el-table-column>

		<el-table-column
		slot="second-column"
		prop="money"
		align="center"
		v-if="isLaowuCompany"
		label="劳务费"
		>
		<template slot-scope="scope">
		<div>
		<el-tag type="success">¥ {{ scope.row.labor_dispatch_money }}</el-tag>
		</div>
		</template>
		</el-table-column>
		<!-- <el-table-column
            slot="first-column"
            align="left"
            prop="settlement_channel.channel_name"
            label="税源地名称"
          >
          </el-table-column> -->
          <el-table-column
            slot="first-column"
            align="center"
            prop="company.name"
            label="公司名称"
          >
          </el-table-column>
          <el-table-column prop="tag_id" align="center" label="标记">
            <template slot-scope="scope">
              <div>
                {{ mark_list_obj[scope.row.tag_id] || '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="alias_msg" align="center" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                size="medium"
                @click="
                  mxViewReceipt(
                    scope.row.outer_trade_no,
                    scope.row.yl_bank,
                    scope.row.channel_account,
                    scope.row.ele_receipt_url
                  )
                "
                type="success"
                plain
                >查看电子回单
              </el-button>
              <el-button size="medium" @click="setMark(scope.row)">标记</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="set_mark_ref" label-position="right" label-width="150px">
          <el-form-item label="标记类型" prop="tag_id">
            <el-select
              v-model="formData.tag_id"
              placeholder="请选择标记类型"
              size="medium"
              filterable
            >
              <el-option
                v-for="item in mark_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-if="formData.tag_id===99" label="关联个人" prop="id_number">
            <el-select
              v-model="formData.id_number"
              placeholder="请选择人员"
              size="medium"
              filterable
            >
              <el-option
                v-for="item in select_customer_list"
                :key="item.id_number"
                :label="item.name + '-'+item.id_number"
                :value="item.id_number"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import api from '@/api'
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import ScreeCompany from "@/components/ScreeCompany.vue";
import MonthPicker from "@/components/MonthPicker.vue";
import ModalDialog from "@/components/ModalDialog.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ScreeCompany,
    MonthPicker,
    ModalDialog
  },
  data() {
    return {
		isLaowu:false,
		isLaowuCompany:false,//劳务
      rules: {
        tag_id: [{required: true, message: '选择类型', trigger: 'change'}],
        id_number: [{required: true, message: '请选择人员', trigger: 'change'}]
      },
      formData:{
        tag_id:'',
        id:'',
        // id_number:''
      },
      mark_list:[],
      select_customer_list:[],
      mark_list_obj:{},
      dialogData:{
        visible: false,
        title: '设定标记',
        width: '30%',
        loading: false,
        modal: false
      },
		quickForm:{
			settlementId:'',
			time:''
		},
		settlementList:[],
      // 允许显示的字段
      allowField: ["companyId", "settlementId", "cardAttribute"],
      bookType: "xlsx", //导出表格类型
      downloadLoading: false,
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      searchCondition: {},
      loadingStaus: true,
      columns: [
        {
          title: "附属信息",
          value: [
            { label: "证件：", value: "id_number" },
            { label: "账户：", value: "bank_account_no" },
            { label: "卡属性：", value: "alias_card_attribute" },
            { label: "备注：", value: "remark" },
            { label: "分行号：", value: "bank_line_no" },
            { label: "支行名称：", value: "bank_branch" },
            { label: "错误代码：", value: "error_code" },
            { label: "错误信息：", value: "error_msg" },
            { label: "银行渠道：", value: "pid" },
          ],
          header_align: "center",
          width: 300,
        },
        {
          title: "税源地名称",
          header_align: "center",
          align: "center",
          value: "sydName",
        },
        {
          title: "推送时间",
          header_align: "center",
          align: "center",
          value: "push_time",
        },
        {
          title: "状态",
          width: 80,
          value: "send_msg",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          width: 150,
          value: "created_at",
          header_align: "center",
          align: "center",
        },
      ],
      tradeWithdrawList: [], // 表格列表数据
      pagingData: {
        // 分页信息
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0, // 分页的offset,序号列使用
    };
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    setMark(e){
      this.formData.id = e.id;
      this.formData.tag_id = e.tag_id || ''
      // this.formData.id_number = e.id_number || ''
      this.dialogData.visible = true;
      // this.getSelectCustomerList(e.company.id, e.channel_account)
    },
    async confirmSetMark(){
      let formData = {
        ...this.formData
      }
      let result = await this.$api.setWithdrawMark(formData)
      if(result){
        this.loading = true;
        setTimeout(()=>{
          this.loading = false;
          this.dialogClose()
          this.init()
        },500)
      }
    },
    // 设定标记相关
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['set_mark_ref'].validate((valid) => {
        if (valid) {
          this.confirmSetMark()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
    },
	clearMonth(){
		this.quickForm.time = ''
	},
    handleDownload_zip(){
     if(this.quickForm.settlementId == ''){
       this.$message.error("请选择税源地")
       return false
     }

    if(this.quickForm.time == ''){
       this.$message.error("请选择月份")
       return false
    }
       let month = this.quickForm.time.split("-")
       let url = `https://img.51xinlong.com/xladmin/channelaccountorder/${this.quickForm.settlementId}${month[0]}${month[1]}.zip`
       fetch(url,
          { method: "HEAD" }
       ).then((res) => {
         if (res.ok) {
          location.href = url
         } else {
         this.$message.error("暂无文件可下载")
         }
       }) 
    },
    settlementChange(v) {
      this.quickForm.settlementId = v
      console.log(this.quickForm)
    },
    // 导出日期
    MonthSearch_quick(v) {
      if (v) {
		this.quickForm.time = v[0].substring(0,7)
		console.log(this.quickForm)
      }
    },
    // 导出日期
    MonthSearch(v) {
      if (v) {
        this.searchCondition.start_time = v[0];
        this.searchCondition.end_time = v[1];
      }
      this.init("search");
    },
    ScreeCompany(v, name) {
      console.log(v, name, "v, name");
      if (name == "company") {
        if (v) {
          this.searchCondition.company_id = v;
        } else {
          delete this.searchCondition.company_id;
        }
        this.init("search");
      }
      if (name == "settlement") {
		let active=	this.settlementList.find(item=>{
			
		return item.channel_account===v
		})
		
		if(active?.channel_account){
			this.isLaowuCompany=active.is_labor_dispatch===1?true:false
		}else{
			this.isLaowuCompany=false
		}
        if (v) {
          this.searchCondition.channel_account = v;
        } else {
          delete this.searchCondition.channel_account;
        }
        this.init("search");
      }
      if (name == "cardAttribute") {
        if (v) {
          this.searchCondition.card_attribute = v;
        } else {
          delete this.searchCondition.card_attribute;
        }
        this.init("search");
      }
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    //选择导出类型
    selectData(e) {
      this.bookType = e;
    },
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let tHeader = [
          "公司名称",
          "税源地名称",
          "订单号",
          "姓名",
          "身份证号",
          "结算金额",
          "卡属性: （C 对私，B 对公）",
          "备注",
          "状态",
          "错误代码",
          "错误信息",
          "下发时间",
        ];
		if(this.isLaowuCompany){
			tHeader.splice(6,0,'劳务费')
		}else{
			tHeader.splice(6,0,'实发金额','个税')
    }
		if(this.isLaowu){
			tHeader.splice(6,0,"实收金额",'增值税',"附加税",'个税')
		}
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `发放列表${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    //转换导出数据
    formatJson(jsonData) {
      console.log(jsonData, "结果");
      return jsonData.map((v) => {
        v.Companyname = v.company ? v.company.name : "";
		v.SydName = v.settlement_channel ? (v.settlement_channel.channel_name + (v.pid_name?`（${v.pid_name}）`:'')) : "";
        let {
          Companyname,
          SydName,
          outer_trade_no,
          bank_account_name,
          id_number,
          money,
          real_money,
          now_tax_money,
          card_attribute,
          remark,
          send_msg,
          error_code,
          error_msg,
          created_at,labor_dispatch_money,value_added_tax,additional_tax,personal_income_tax,after_tax_money
        } = v;
		let arr=[
          Companyname,
          SydName,
          outer_trade_no,
          bank_account_name,
          id_number,
          money,
          card_attribute,
          remark,
          send_msg,
          error_code,
          error_msg,
          created_at,
        ];
		if(this.isLaowuCompany){
			arr.splice(6,0,labor_dispatch_money)
		}else{
			arr.splice(6,0, real_money,now_tax_money)
    }
		if(this.isLaowu){
			arr.splice(6,0,after_tax_money,value_added_tax,additional_tax,personal_income_tax)
		}
		return arr
      });
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },
    async getSelectCustomerList(company_id,channel_account){
      let data = {
        channel_account,
        company_id,
        current_page:1,
        page_size:9999
      }
      let result = await api.getSelectCustomerList(data)
      this.select_customer_list = result

      console.log(this.mark_list,'标记列表')
    },
    async getMarkList(){
      let result = await api.getWithdrawMarkList()
      let mark_list = []
      for(let key in result){
        let item = {
          value:+key,
          label:result[key]
        }
        mark_list.push(item)
      }
      this.mark_list = mark_list
      this.mark_list_obj = result

      console.log(this.mark_list,'标记列表')
    },
    // 初始化文章列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
        page_size:10,
        current_page:1
      };

      if (type == "export") {
        pagingInfo.page_size = 10000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);

      let { data, pages } = await this.$api.getMxWithdrawList(searchCondition);

      console.log(searchCondition);
      console.log(data);

      /*------------------------  设置导出时 分页累加数据  --------------------------*/
      let exportData = data;
      if (type === "export") {
        let multiple = parseInt(pages.total / pagingInfo.page_size);
        if (multiple > 0) {
          multiple += 1;
        }
        for (let i = 2; i <= multiple; i++) {
          searchCondition.current_page = i;
          let { data } = await this.$api.getMxWithdrawList(searchCondition) ;
          exportData = exportData.concat(data);
        }
      }
      /*------------------------  设置导出时 分页累加数据  --------------------------*/

      if (type == "export") {
        return exportData;
      } else {
        this.tradeWithdrawList = [];
        this.$nextTick(() => {
          this.tradeWithdrawList = data;
          this.tradeWithdrawList.forEach((item) => {
            item.sydName = item.settlement_channel.channel_name + (item.pid_name?`（${item.pid_name}）`:'');
            switch (item.pid) {
              case "ws":
                item.pid = "网商银行";
                break;
              case "yinglin":
                item.pid = "银灵科技";
                break;
              default:
                break;
            }
          });
        });
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.query) {
        condition.query = this.searchCondition.query;
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time;
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time;
      }
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id;
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account;
      }
      if (this.searchCondition.card_attribute) {
        condition.card_attribute = this.searchCondition.card_attribute;
      }
      if (this.searchCondition.tag_id) {
        condition.tag_id = this.searchCondition.tag_id;
      }
      return condition;
    },
  },
  async mounted() {
    await this.getMarkList();
    this.init();
    let result = await api.tenantCategoryList()
    this.settlementList = result
    this.quickForm.settlementId = result[0].channel_account
	if(localStorage.getItem('user_info')){
		let obj = JSON.parse(localStorage.getItem('user_info'))
		if(obj.tenant_id == '638310559502782464'){
			this.isLaowu = true
		}
	}
  },
};
</script>

<style lang="stylus" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.el-table {
  font-size: 14px;
}

.table-right {
  float: right;
}

.select-box {
  width: 100px;
}

.table-search {
  height: 36px;
}
</style>
